import React from 'react';
import ModuleWrap from "../ModuleWrap/ModuleWrap";

const Cooperation = (props) => {
    return (
        <ModuleWrap title="Współpraca" icon={props.icon}>
            Zapraszamy do współpracy wytwórców palet z całej Polski. Gwarantujemy stały poziom cen, krótkie terminy zapłaty oraz terminowość odbioru palet. Oferujemy również długoterminowe umowy.
        </ModuleWrap>
    )
};

export default Cooperation;


// WEBPACK FOOTER //
// ./src/components/Cooperation/Cooperation.js